import React,{useState} from "react";
import "./ServiceUrban.css";
import VideoCorousel from "../Component/VideoCorousel/VideoCorousel";
import { useNavigate } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";import { Box, Typography, Grid } from "@mui/material";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Link } from 'react-router-dom';
  import { Dialog, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

export default function ServiceUrban() {
 const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentImage, setCurrentImage] = useState(null);

  const handleImageClick = (image) => {
    setCurrentImage(image);
    setIsModalOpen(true);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
    setCurrentImage(null);
  };


  const navigate = useNavigate();
 const [open, setOpen] = useState(false);
 const Images = [
 { src: "assets/ser-1.jpg", alt: "Custom Home" },
 { src: "assets/ser-2.jpg", alt: "Custom Home" },
 { src: "assets/ser-3.jpg", alt: "Custom Home" },
 { src: "assets/ser-4.jpg", alt: "Custom Home" },
 { src: "assets/ser-5.jpg", alt: "Custom Home" },
 { src: "assets/ser-6.jpg", alt: "Custom Home" },
];
  // Combine all images from all sections into a single array

  const customImages =[
{ src: "assets/service-sec-1.jpeg", alt: "Custom Home" },
    // { src: "assets/CustomHome2.jpg", alt: "Custom Home Interior" },
    // { src: "assets/CustomHome3.jpg", alt: "Custom Home Exterior" },


  ];
  const communityImages =[
    { src: "assets/Image (3).jpg", alt: "Community Development" },
    // { src: "assets/Community2.jpg", alt: "Community Park" },
    // { src: "assets/Community3.jpg", alt: "Community Amenities" },

  ];
  const renovationImages =[
 { src: "assets/Image(2).jpg", alt: "Renovations" },
    // { src: "assets/Renovation2.jpg", alt: "Kitchen Renovation" },
    // { src: "assets/Renovation3.jpg", alt: "Bathroom Renovation" },

  ];
  const interiorImages =[
{ src: "assets/Interior-Desigm-service-page.jpg", alt: "Renovations" },
    // { src: "assets/InteriorDesign2.jpg", alt: "Living Room Design" },
    // { src: "assets/InteriorDesign3.jpg", alt: "Bedroom Design" },

  ];
  const whyUsData = [
  // {
  //   title: "LICENSED EXPERTS",
  //   subtitle: "Certified by Government Bodies",
  //   content:
  //     "Urban Casa Constructions is licensed by national authorities. We work with certified professionals only, ensuring every project meets stringent safety and quality standards.",
  //   image: "/assets/Image (3).jpg",
  // },
  {
    title: "PREMIUM FEATURES",
    subtitle: "Luxury is Our Standard",
    content:
      "What others call luxury upgrades, we deliver as standard. Every home we build includes top-tier inclusions, all at no hidden extra costs.",
    image: "/assets/ser-7.jpg",
  },
  {
    title: "CLARITY IN PROCESS",
    subtitle: "Easy to Understand Contracts",
    content:
      "No jargon, no confusion. Our tender and contract system is designed to be straightforward so you know exactly what you’re getting — no surprises.",
    image: "/assets/ser-8.jpg",
  },
  {
    title: "CLARITY IN PROCESS",
    subtitle: "Easy to Understand Contracts",
    content:
      "No jargon, no confusion. Our tender and contract system is designed to be straightforward so you know exactly what you’re getting — no surprises.",
    image: "/assets/ser-6.jpg",
  },
  // {
  //   title: "LICENSED EXPERTS",
  //   subtitle: "Certified by Government Bodies",
  //   content:
  //     "Urban Casa Constructions is licensed by national authorities. We work with certified professionals only, ensuring every project meets stringent safety and quality standards.",
  //   image: "/assets/Image (3).jpg",
  // },
  
];


  return (
    <div>
      <VideoCorousel />
      <div className="nanak-announcement-wrapper">
        <h1 className="nanak-heading">
          AUSTRALIA’S MOST AMBITIOUS DISPLAY HOME IS{" "}
          <span className="highlight">COMING SOON</span>
        </h1>

        <p className="nanak-description">
          UrbanCasa is proud to unveil a new era of residential excellence. Our grandest display home yet is currently under construction at HomeQuest, Bella Vista — a showcase of cutting-edge design, unmatched luxury, and superior craftsmanship.
        </p>

        <p className="nanak-note">
Stay tuned — your first look at next-level living is just around the corner.        </p>

        <button className="nanak-cta-button" onClick={() => setOpen(true)}>
          <span className="top">CLICK FOR</span>
          <span className="bottom">MORE DETAILS</span>
        </button>
      </div>

      {/* Popup Modal */}
      {open && (
        <div className="nanak-modal-overlay" onClick={() => setOpen(false)}>
          <div className="nanak-modal" onClick={(e) => e.stopPropagation()}>
            <h2 className="modal-title">About Urban Casa</h2>
            <p className="modal-description">
              At <strong>Urban Casa</strong>,  we specialise in crafting modern, high-quality homes designed for real lifestyles. With years of experience in the Australian housing market, we’re known for:

            </p>
            <ul className="modal-list">
              <li>🏗 Innovative building techniques</li>
              <li>🎨 Custom-designed layouts & finishes</li>
              <li>🌱 Energy-efficient & sustainable homes</li>
              <li>🛠 Premium materials & skilled craftsmanship</li>
              <li>🤝 Personalised, client-focused service
</li>
            </ul>
            <p className="modal-footer">
              Build smart. Live beautifully. Only with Urban Casa.
            </p>
            <button className="close-btn" onClick={() => setOpen(false)}>
              Close
            </button>
          </div>
        </div>
      )}

      <div className="services-page-heading-urban-casa-main-heading">
        SERVICES
      </div>
      <div className="parent">
        <div className="child1">
          <h1 className="Residential">Residential</h1>
          <h1 className="construction">Construction</h1>
       <Link to="/contact">  <button className="button" >Schedule a Call</button> </Link> 
          <div className="youtube-video-section-urban-casa">
             <section className="unique-designs-section">
      <div className="unique-text-container">
        <h2>OUR UNIQUE DESIGNS</h2>
  
      <p>
  At <strong>Urban Casa </strong>, we believe a home should be more than just a place to live — it should be a true reflection of your personality, values, and lifestyle. Our unique designs are crafted with precision, blending modern architecture, practical functionality, and refined aesthetics to deliver homes that feel as good as they look.
</p>
<p>

From bold facades to elegant interiors, each Urban Casa home is built to stand out. With a focus on smart living, space optimisation, and timeless appeal, we create homes that are both beautiful and built for the future.

</p>
<p>
 Every design is thoughtfully planned — clean lines, sustainable materials, open layouts, and natural light come together to enhance comfort, flow, and everyday living. Whether you're looking for a peaceful retreat or a vibrant family hub, <strong> Urban Casa </strong> turns your vision into a space you’ll love coming home to.

</p>
<p>
  Join us on a journey where innovation meets craftsmanship, and discover a home that’s uniquely you — only at <strong> Urban Casa</strong>.
</p>
<p>
  Whether you're dreaming of a peaceful retreat or a vibrant social hub, Urban Casa redefines what it means to live
  in style. Join us on a journey where thoughtful design meets exceptional craftsmanship, and discover a home that
  truly reflects who you are.
</p>

      </div>

       <div className="unique-video-gallery">
      {Images.map((image, index) => (
        <div
          key={index}
          className="video-wrapper"
          style={{ cursor: "pointer" }}
          onClick={() => handleImageClick(image.src)}
        >
          <img
            src={image.src}
            alt={image.alt || `carousel-img-${index}`}
            className="unique-images-responsive"
          />
        </div>
      ))}

      {/* Popup Modal */}
      <Dialog open={isModalOpen} onClose={handleModalClose} maxWidth="lg">
        <div style={{ position: "relative" }}>
          <IconButton
            onClick={handleModalClose}
            sx={{ position: "absolute", top: 10, right: 10, color: "white", zIndex: 10 }}
          >
            <CloseIcon />
          </IconButton>
          {currentImage && (
            <img
              src={currentImage}
              alt="Selected"
              style={{
                maxWidth: "90vw",
                maxHeight: "90vh",
                display: "block",
                margin: "auto",
              }}
            />
          )}
        </div>
      </Dialog>
    </div>
    </section>
     <Box sx={{ background: "#000", color: "#fff", py: 10, px: { xs: 2, md: 4 } }}>
      <Typography
        align="start"
        sx={{
          fontWeight: "bold",
          mb: 2,
          color: "#d4af37",
          textTransform: "uppercase",
          fontSize:{xs:"6vw",lg:"2vw"}
        }}
      >
        WHY URBAN CASA
      </Typography>
      <Typography align="start" sx={{ mb: 5, fontSize: "18px" }}>
        Building with trust, clarity, and modern luxury.
      </Typography>

      <Grid container spacing={6}>
        {whyUsData.map((item, index) => (
          <Grid item xs={12} md={8} key={index}sx={{ display:"flex",flexDirection:"column", alignItems:{xs:"center",lg:"flex-start"}}}>
            <Box  sx={{width:{lg:"30vw",}}}>
              <img className="urban-casa-why-urban-services-page-block"
                src={item.image}
                alt={item.title}
                style={{  borderRadius: "12px", marginBottom: "20px" }}
               
              />
            </Box>
            <Box pl={{ md: 4 }}>
              <Typography  sx={{ fontWeight: 700, color: "#fff",fontSize:{xs:"4vw",lg:"1.3vw"} , textAlign:{xs:"center",lg:"start"} }}>
                {item.title}
              </Typography>
              <Typography sx={{ color: "#d4af37", mb: 1 ,fontSize:{xs:"3vw",lg:"1.1vw"}}}>{item.subtitle}</Typography>
              <Typography sx={{fontSize:{xs:"2.4vw",lg:"1vw"}}}> {item.content}</Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
          </div>
        </div>

        <div className="child2"
        >
          
          <p className="para1">
           UrbanCasa brings years of experience and a passion for excellence to every residential project — from bespoke custom homes to large-scale community developments and transformative renovations. Our dedicated team collaborates closely with each client to understand their unique goals, lifestyle, and aesthetic preferences. Every space we create is thoughtfully designed and skillfully built to reflect individual vision, ensuring that every detail speaks to the way you live.
          </p>

          <h1 className="urban-casa-service-head-type">Custom Homes</h1>
             {/* SINGLE IMAGE CAROUSEL */}
          <div style={{ marginTop: "40px", marginBottom: "60px" }}>
            <Swiper
              modules={[Navigation,Pagination]}
              spaceBetween={20}
              slidesPerView={1}
              navigation
              pagination={{ clickable: true }}
              loop={true}
              style={{ maxWidth: "900px", margin: "auto" }}
            >
              {customImages.map((img, index) => (
                <SwiperSlide key={index}>
                  <img
                    src={img.src}
                    alt={img.alt || `carousel-img-${index}`}
                    style={{
                      width: "100%",
                      maxHeight: "450px",
                      objectFit: "cover",
                      borderRadius: "8px",
                      boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
                    }}
                  />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
          <p className="para2">
            At UrbanCasa, we take pride in designing and building custom homes that are a true reflection of your lifestyle, personality, and long-term vision. Whether your style leans toward sleek modern living or timeless sophistication, our team works closely with you to bring your dream home to life — blending creativity with functionality at every step.
            <br />
            We prioritize sustainable design and forward-thinking solutions, integrating energy-efficient systems like solar panels, smart technologies, and high-performance insulation to create homes that are both eco-friendly and future-ready.
            From foundation to finishing touches, we ensure quality craftsmanship, attention to detail, and transparent communication throughout the process.
          <br></br>
          From the ground up, every detail is handled with precision and care. With a commitment to exceptional craftsmanship and open, transparent communication, we make the journey of building your custom home seamless, inspiring, and uniquely yours.
          </p>
          <button className="urban-services-redirect-btn" onClick={() => navigate("/custom-homes")}>Custom Homes</button>

          {/* <h1 className="urban-casa-service-head-type">Community Development</h1>
          <div style={{ marginTop: "40px", marginBottom: "60px" }}>
            <Swiper
              modules={[Navigation, Pagination]}
              spaceBetween={20}
              slidesPerView={1}
              navigation
              pagination={{ clickable: true }}
              loop={true}
              style={{ maxWidth: "900px", margin: "auto" }}
            >
              {communityImages.map((img, index) => (
                <SwiperSlide key={index}>
                  <img
                    src={img.src}
                    alt={img.alt || `carousel-img-${index}`}
                    style={{
                      width: "100%",
                      maxHeight: "450px",
                      objectFit: "cover",
                      borderRadius: "8px",
                      boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
                    }}
                  />
                </SwiperSlide>
              ))}
            </Swiper>
          </div> */}
          {/* <p className="para3">
            At UrbanCasa, we’re committed to creating vibrant, sustainable communities that elevate everyday living and foster genuine connection. With a strong focus on collaboration, we partner with local councils, urban planners, and community stakeholders to ensure each development is environmentally conscious, socially inclusive, and economically sustainable
            <br />
            Our community projects are thoughtfully designed with green spaces, walkable layouts, accessible transport links, and essential amenities like parks, schools, and retail hubs — all contributing to a well-rounded, enriching lifestyle. At UrbanCasa, we blend forward-thinking design with local character, building neighborhoods that feel both modern and deeply rooted in place.
            
          </p>
          <button className="urban-services-redirect-btn" onClick={() => navigate("/community-development")}>Community Development</button> */}

          <h1 className="urban-casa-service-head-type">Renovations</h1>
             {/* SINGLE IMAGE CAROUSEL */}
          <div style={{ marginTop: "40px", marginBottom: "60px" }}>
            <Swiper
              modules={[Navigation, Pagination]}
              spaceBetween={20}
              slidesPerView={1}
              navigation
              pagination={{ clickable: true }}
              loop={true}
              style={{ maxWidth: "900px", margin: "auto" }}
            >
              {renovationImages.map((img, index) => (
                <SwiperSlide key={index}>
                  <img
                    src={img.src}
                    alt={img.alt || `carousel-img-${index}`}
                    style={{
                      width: "100%",
                      maxHeight: "450px",
                      objectFit: "cover",
                      borderRadius: "8px",
                      boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
                    }}
                  />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
          <p>
           At UrbanCasa, whether you're refreshing a single space or reimagining your entire home, we bring the expertise and creativity to make your renovation vision a reality. Our renovation team works closely with you to understand your lifestyle, goals, and budget — offering smart, stylish solutions that enhance light, space, and functionality.
            <br />
            From modern kitchen upgrades and luxurious bathroom remodels to full structural transformations and sustainable retrofits, every project is carried out with meticulous attention to detail and quality craftsmanship. We prioritize a smooth, efficient process that minimizes disruption while maximizing the beauty, comfort, and long-term value of your home.
            
          </p>
          <button className="urban-services-redirect-btn" onClick={() => navigate("/RenovationDesign")}>Renovations</button>

          <h1 className="urban-casa-service-head-type">Interior Design</h1>
             {/* SINGLE IMAGE CAROUSEL */}
          <div style={{ marginTop: "40px", marginBottom: "60px" }}>
            <Swiper
              modules={[Navigation, Pagination]}
              spaceBetween={20}
              slidesPerView={1}
              navigation
              pagination={{ clickable: true }}
              loop={true}
              style={{ maxWidth: "900px", margin: "auto" }}
            >
              {interiorImages.map((img, index) => (
                <SwiperSlide key={index}>
                  <img
                    src={img.src}
                    alt={img.alt || `carousel-img-${index}`}
                    style={{
                      width: "100%",
                      maxHeight: "450px",
                      objectFit: "cover",
                      borderRadius: "8px",
                      boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
                    }}
                  />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
          <p>
          UrbanCasa also offers professional interior design services to transform your home’s interiors into a true reflection of your style and lifestyle. Our talented designers blend aesthetics with functionality, crafting interiors that are not only visually stunning but also comfortable and practical.
            <br />
We provide fully personalized design plans — from thoughtful furniture layouts and ambient lighting to curated color palettes and decor selections — ensuring every detail contributes to a cohesive, inviting atmosphere. Whether your taste is modern, timeless, or uniquely eclectic, UrbanCasa delivers bespoke interior solutions that elevate the way you live.            <br />
            Whether modern, classic, or eclectic, our team delivers personalized solutions that elevate your living environment.
          </p>
          <button className="urban-services-redirect-btn" onClick={() => navigate("/InteriorDesign")}>Interior Design</button>

          {/* SINGLE IMAGE CAROUSEL */}
          {/* <div style={{ marginTop: "40px", marginBottom: "60px" }}>
            <Swiper
              modules={[Navigation, Pagination]}
              spaceBetween={20}
              slidesPerView={1}
              navigation
              pagination={{ clickable: true }}
              loop={true}
              style={{ maxWidth: "900px", margin: "auto" }}
            >
              {interiorImages.map((img, index) => (
                <SwiperSlide key={index}>
                  <img
                    src={img.src}
                    alt={img.alt || `carousel-img-${index}`}
                    style={{
                      width: "100%",
                      maxHeight: "450px",
                      objectFit: "cover",
                      borderRadius: "8px",
                      boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
                    }}
                  />
                </SwiperSlide>
              ))}
            </Swiper>
          </div> */}
        </div>
      </div>
    </div>
  );
}
